<app-page-title [heading]="heading" [subheading]="subheading" [icon]="icon" [menuConfiguration]="headerMenuConfiguration">
</app-page-title>
<div *ngIf="!usersService.hasSelectedCompanyModuleRight('Audiences', 'AudiencesList') && !usersService.hasSelectedCompanyModuleRight('Audiences', 'AudiencesTransfers')">
    You have no rights to access this page
</div>
<div *ngIf="usersService.hasSelectedCompanyModuleRight('Audiences', 'AudiencesList') || usersService.hasSelectedCompanyModuleRight('Audiences', 'AudiencesTransfers')">
    <transfers-block [filter]="filter" style="width: 100%;"></transfers-block>
</div>